export type IntentCategory =
  | 'CURRENCY_CONVERSION'
  | 'MONEY_TRANSFER'
  | 'SALARY_CALCULATION'
  | 'LOAN_MORTGAGE'
  | 'SAVINGS_WEALTH'
  | 'UNIVERSAL_CALCULATOR'
  | 'KNOWLEDGE_SEARCH'
  | 'UNKNOWN';

export interface IntentPlan {
  primaryIntent: IntentCategory;
  secondaryIntents: IntentCategory[];
  entities: Record<string, string | number>;
  requiredTools: string[];
  confidence: 'HIGH' | 'MEDIUM' | 'LOW';
  missingInformation: string[];
}

export function parseIntentDeterministic(query: string): IntentPlan {
  const q = query.toLowerCase();

  // Currency
  if (q.includes('to') && (q.includes('usd') || q.includes('eur') || q.includes('gbp') || q.includes('cad') || q.includes('jpy') || q.includes('convert'))) {
    return {
      primaryIntent: 'CURRENCY_CONVERSION',
      secondaryIntents: [],
      entities: { query },
      requiredTools: ['currency_converter_tool'],
      confidence: 'HIGH',
      missingInformation: [],
    };
  }

  // Money Transfer
  if (q.includes('send') || q.includes('transfer') || q.includes('remittance') || q.includes('provider')) {
    return {
      primaryIntent: 'MONEY_TRANSFER',
      secondaryIntents: [],
      entities: { query },
      requiredTools: ['money_transfer_tool'],
      confidence: 'HIGH',
      missingInformation: [],
    };
  }

  // Salary / Tax
  if (q.includes('salary') || q.includes('paycheck') || q.includes('tax') || q.includes('net income') || q.includes('earn')) {
    return {
      primaryIntent: 'SALARY_CALCULATION',
      secondaryIntents: [],
      entities: { query },
      requiredTools: ['salary_engine_tool'],
      confidence: 'HIGH',
      missingInformation: [],
    };
  }

  // Loan / Mortgage
  if (q.includes('loan') || q.includes('mortgage') || q.includes('affordability') || q.includes('apr') || q.includes('interest rate')) {
    return {
      primaryIntent: 'LOAN_MORTGAGE',
      secondaryIntents: [],
      entities: { query },
      requiredTools: ['loan_mortgage_tool'],
      confidence: 'HIGH',
      missingInformation: [],
    };
  }

  // Savings / Wealth / FIRE
  if (q.includes('save') || q.includes('saving') || q.includes('compound') || q.includes('fire') || q.includes('retirement') || q.includes('invest')) {
    return {
      primaryIntent: 'SAVINGS_WEALTH',
      secondaryIntents: [],
      entities: { query },
      requiredTools: ['wealth_savings_tool'],
      confidence: 'HIGH',
      missingInformation: [],
    };
  }

  // Percentage / Discount / Vat / Calculator
  if (q.includes('%') || q.includes('percent') || q.includes('discount') || q.includes('vat') || q.includes('tip') || q.includes('off') || q.includes('calc')) {
    return {
      primaryIntent: 'UNIVERSAL_CALCULATOR',
      secondaryIntents: [],
      entities: { query },
      requiredTools: ['universal_calculator_tool'],
      confidence: 'HIGH',
      missingInformation: [],
    };
  }

  // Default Knowledge / RAG Search
  return {
    primaryIntent: 'KNOWLEDGE_SEARCH',
    secondaryIntents: [],
    entities: { query },
    requiredTools: ['knowledge_search_tool'],
    confidence: 'MEDIUM',
    missingInformation: [],
  };
}
